import { createFileRoute } from "@tanstack/react-router";

import { SealButton } from "@/components/site/ctas";
import { Reveal } from "@/components/site/motion";
import { getDict, href, type Lang } from "@/content/site";

export const Route = createFileRoute("/$lang/beyond-sourcing")({
  loader: ({ params }) => ({ lang: params.lang as Lang }),
  head: ({ loaderData }) => {
    const t = getDict(loaderData?.lang ?? "en");
    return { meta: [{ title: `${t.advantage.title} · insidermark` }, { name: "description", content: t.advantage.subtitle }] };
  },
  component: Page,
});

function Page() {
  const { lang } = Route.useLoaderData();
  const t = getDict(lang);
  const a = t.advantage;
  return (
    <main>
      <header className="im-page-head">
        <div className="im-wrap">
          <Reveal>
            <h1 className="im-display">{a.title}</h1>
            <p className="im-body-text mt-5">{a.subtitle}</p>
            <p className="im-body-text mt-5">{a.intro}</p>
          </Reveal>
        </div>
      </header>

      {a.blocks.map((b) => (
        <section className="im-section" id={`advantage-${b.n}`} key={b.n}>
          <div className="im-wrap im-two">
            <Reveal>
              <span className="im-layer__n">
                {b.n} / 0{a.blocks.length}
              </span>
              <p className="im-eyebrow mt-3">{b.label}</p>
              <h2 className="im-display-sm mt-3">{b.myth}</h2>
              <p className="im-body-text mt-5">{b.mythBody}</p>
            </Reveal>
            <Reveal axis="x">
              <h3 className="im-h3">{b.truth}</h3>
              <div className="im-prose mt-4">
                <p>{b.truthBody}</p>
              </div>
            </Reveal>
          </div>
        </section>
      ))}

      <section className="im-section">
        <div className="im-wrap im-rel">
          <Reveal className="im-closing">
            <h2 className="im-display max-w-[20ch]">{a.ctaLine}</h2>
            <div className="im-closing__ctas">
              <SealButton to={href(lang, "/rfq")}>{a.ctaRfq}</SealButton>
              <SealButton href={href(lang, "/contact#executive-desk")}>{a.ctaDesk}</SealButton>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
